import React from "react";
import { useField } from "formik";
import { Select as AntdSelect } from "antd";

// Bỏ dấu tiếng Việt để gõ "thanh xuan" vẫn ra "Thanh Xuân"
const noAccent = (s: string) =>
  s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/đ/g, "d").replace(/Đ/g, "D").toLowerCase().trim();

interface SelectProps {
  name: string;
  label?: string;
  options: Array<{
    label: string;
    value: string | number;
  }>;
  placeholder?: string;
  wrapperClassName?: string;
  className?: string;
  onChange?: (value: string | number) => void;
  onClear?: () => void;
  allowClear?: boolean;
}

const Select: React.FC<SelectProps> = ({
  name,
  label,
  options,
  placeholder,
  className,
  onChange,
  wrapperClassName,
  onClear,
  allowClear,
  ...props
}) => {
  const [field, meta] = useField(name);
  // Value là ID nhưng options chưa có (API chậm / cache rỗng) → hiện placeholder, không lộ ID thô
  const hasOption =
    field.value === undefined ||
    field.value === null ||
    field.value === "" ||
    (options || []).some((o) => o.value === field.value);
  // "" cũng → undefined để AntD hiện placeholder thay vì ô trống kèm nút xoá
  const shownValue = hasOption && field.value !== "" ? field.value : undefined;
  return (
    <div className={`flex flex-col gap-2 w-full ${wrapperClassName}`}>
      {label && (
        <label htmlFor={name} className="text-sm font-medium text-gray-700">
          {label}
        </label>
      )}
      <AntdSelect
        id={name}
        {...field}
        {...props}
        value={shownValue}
        showSearch={(options || []).length > 8}
        optionFilterProp="label"
        filterOption={(input, option) =>
          noAccent(String(option?.label ?? "")).includes(noAccent(input))
        }
        onChange={(value) => {
          if (!!onChange) onChange(value);
          field.onChange({ target: { name, value } });
        }}
        options={options}
        placeholder={placeholder}
        className={className}
        onClear={onClear}
        allowClear={allowClear}
        style={{ width: "100%" }}
      />
      {meta.touched && meta.error && (
        <div className="text-error text-sm mt-1">{meta.error}</div>
      )}
    </div>
  );
};

export default Select;
